import React, { useEffect } from "react";
import Slider from "react-slick";
import ProductThumbnail from "../../../../components/Package/components/ProductThumbnail";
import { sliderSettings } from "./constants";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "./index.css";

export default function ProductCarousel({
  productsWithAddress,
  sliderRef,
  hoveredLocation,
}) {
  useEffect(() => {
    if (sliderRef && hoveredLocation) {
      sliderRef.slickGoTo(hoveredLocation.slideIndex);
    } else sliderRef.slickGoTo(0);
  }, [hoveredLocation]);

  return (
    <Slider
      ref={(c) => (sliderRef = c)}
      {...sliderSettings(productsWithAddress.length)}
      style={{ width: "100%" }}
    >
      {productsWithAddress.map((product, i) => (
        <div key={i} className="product-carousel__slide">
          <ProductThumbnail productData={product} />
        </div>
      ))}
    </Slider>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Products/components/ProductCarousel/index.js